import { ConfidentialClientApplication } from "@azure/msal-node";
import { EnvVar, envOrError } from "@utils/envHelpers";
import { isNullOrEmpty } from "@utils/string";

// Lazy-loaded to prevent crashes if/when included in client bundle
let client: ConfidentialClientApplication | undefined = undefined;
const getClient = () => {
  if (!client) {
    client = new ConfidentialClientApplication({
      auth: {
        clientId: envOrError(EnvVar.APP_REGISTRATION_CLIENT_ID),
        authority: "https://login.microsoftonline.com/1063e17f-0bdd-44f1-9b47-8a99cc3d9e5c",
        clientSecret: envOrError(EnvVar.APP_REGISTRATION_CLIENT_SECRET),
      },
    });
  }
  return client;
};

export const getAzureAdToken = async (scope: string) => {
  const acquiredToken = await getClient().acquireTokenByClientCredential({
    scopes: [`api://${scope}/.default`],
  });

  if (!acquiredToken?.accessToken || isNullOrEmpty(acquiredToken?.accessToken)) {
    throw new Error("Failed to acquire Azure access token");
  }

  return acquiredToken.accessToken;
};
